import { RouteConfig } from 'vue-router';

const Login = () => import(/* webpackChunkName: "Access" */  './views/login/login.vue');
const Register = () => import(/* webpackChunkName: "Access" */  './views/register/register.vue');
const FastLogin = () => import(/* webpackChunkName: "Access" */  './views/fast-login/fast-login.vue');
const Agreement = () => import(/* webpackChunkName: "Access" */  './views/agreement/agreement.vue');



const routers: RouteConfig[] = [
    {
        path: 'login',
        name: 'login',
        component: Login
    },
    // {
    //     path: 'register',
    //     name: 'register',
    //     component: Register
    // },
    {
        path: 'fast-login/:module/:loginname/:password',
        component: FastLogin
    },
    {
        path: 'agreement',
        component: Agreement
    },
    {
        path: '',
        redirect: 'login'
    },
];

export default routers;

